import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import FullScreenLoader from "./components/FullScreenLoader";
import AuthPage from "./pages/AuthPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import HomePage from "./pages/HomePage";
import LandingPage from "./pages/LandingPage";
import AnalyticsRouteTracker from "./components/AnalyticsRouteTracker";
import MetaRouteTracker from "./components/MetaRouteTracker";
import Cookies from "./components/Cookies";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <FullScreenLoader message="Checking authentication..." />;
  }

  if (!user) {
    return <Navigate to="/signup" replace />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <>
      <AnalyticsRouteTracker />
      <MetaRouteTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/20m" element={<ComingSoonPage />} />
        <Route path="/signup" element={<AuthPage mode="signup" />} />
        <Route path="/login" element={<AuthPage mode="signin" />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Cookies />
    </>
  );
};

export default App;
